import { SelectGroup } from "@/components/ui/select";

export function LocationSelect({ currentExport, data, setData, dataOptions }) {
  if (
    currentExport == "asset" ||
    currentExport == "part repairable" ||
    currentExport == "part non repairable"
  ) {
    return (
      <SelectGroup
        label="Location"
        menuPosition="fixed"
        isClearable
        placeholder="Select Location"
        className="w-full"
        options={
          currentExport == "asset"
            ? dataOptions.assets || []
            : currentExport == "part repairable"
              ? dataOptions.part_repairables || []
              : dataOptions.part_non_repairables || []
        }
        value={(currentExport == "asset"
          ? dataOptions.assets
          : currentExport == "part repairable"
            ? dataOptions.part_repairables
            : dataOptions.part_non_repairables
        )?.filter(
          (option) =>
            option.location_id === data.location_id &&
            option.location_type === data.location_type,
        )}
        onChange={(e) => {
          setData({
            ...data,
            location_id: e ? e.location_id : null,
            location_type: e ? e.location_type : null,
          });
        }}
      />
    );
  }
  return null;
}
